import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../utils";
import Button from "../../Button";
import { presets } from "../constants";
const DatePresets = ({ selectedPreset, availablePresets, onSelectPreset }) => {
    const presetsToRender = availablePresets?.length ? presets.filter((preset) => availablePresets.includes(preset.key)) : presets;
    return (_jsx("div", { className: "space-y-2", children: presetsToRender.map((preset) => {
            const isSelected = selectedPreset === preset.key;
            return (_jsx(Button, { variant: "text", color: isSelected ? "primary" : "default", className: cn("justify-start", isSelected && "bg-primary-5"), full: true, onClick: () => onSelectPreset(preset), children: preset.label }, preset.label));
        }) }));
};
export default DatePresets;
